module.exports = __webpack_public_path__ + "static/media/metamask.7195f2eb.png";